import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const SideBarLinks = ({
  content,
  icon,
  dropdown = false,
  dropdownItems = [],
  url = '/',
  setIsSidebarOpen
}) => {
  // State to manage the visibility of the dropdown
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Function to toggle dropdown visibility on click
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleSideBarToggle = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <li
      className="relative px-4 mt-2"
      onClick={dropdown ? toggleDropdown : undefined}
    >
      <div className="flex justify-between items-center gap-2 cursor-pointer">
        {dropdown ? 
          <>
            <button type="button" className="flex gap-x-2 items-center"><span>{icon}</span> <span>{content}</span></button> 
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-4"
            >
              <path
                fillRule="evenodd"
                d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z"
                clipRule="evenodd"
              />
            </svg>
          </>: 
          <NavLink to={url} onClick={handleSideBarToggle} className={'flex justify-between items-center gap-2 cursor-pointer'}> {/* handleSideBarToggle IS WORKING HERE */}
            <span>{icon}</span>
            <span>{content}</span>
          </NavLink>}
      </div>
      {dropdown && (
        <ul
          className={`ml-4 mt-2 bg-gray-100 rounded-md overflow-hidden ${
            isDropdownOpen
              ? "max-h-60 opacity-100 translate-y-0" // when open
              : "max-h-0 opacity-0 translate-y-[-10px]" // when closed
          } transition-all duration-300 ease-in-out`}
        >
          {dropdownItems.map(({href,label,icon}, index) => (
            <li
              key={index}
              className="p-2 text-dark hover:-translate-x-2 hover:shadow-md hover:bg-gray-200 transform transition-all duration-150"
            >
              <NavLink to={href} onClick={handleSideBarToggle} className="flex gap-2">{icon} {label}</NavLink> {/* handleSideBarToggle IS NOT WORKING HERE */}
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SideBarLinks;
